import SearchBar from "@/views/fin/account_management/SearchBar.jsx";
import DataTable from "@/views/fin/account_management/DataTable.jsx";
import VPage from "@/vuetify_custom/v-pagination";
import styles from "@/views/fin/account_management/index.module.less";
import {
  getEpopAccountQueryApi,
  getEpopAccountMineQueryApi,
} from "@/views/fin/account_management/services.js";
export default {
  props: {
    isFin: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      platform_list: [],
      list: [],
      loading: false,
      params: {
        page: 1,
        per_page: 20,
        total_count: 0,
        account_type: null,
        platform_id: null,
        team_id: null,
        customer_id: null,
        account_status: null,
        search: null,
        year_month: null,
        verified: null,
      },
    };
  },
  computed: {
    isManagePerson() {
      const current_hash = this.$store.state.hash_authority || {};
      return current_hash["account_management_button_input"];
    },
    canBatchInputData() {
      // 财务与有权限的人
      return this.isFin || this.isManagePerson;
    },
    canInputData() {
      // 财务与有权限的人
      return this.canBatchInputData;
    },
  },
  created() {
    this.getEpopAccountQuery();
  },
  methods: {
    getEpopAccountQuery(params) {
      params = params || {};
      this.loading = true;
      const api = this.isFin
        ? getEpopAccountQueryApi
        : getEpopAccountMineQueryApi;
      api({ ...this.params, ...params })
        .then((res) => {
          this.list = res.epop_accounts;
          this.params.page = res.cur_page;
          this.params.per_page = res.per_page;
          this.params.total_count = res.total_count;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  render() {
    return (
      <div class={styles["contain"]}>
        <div class={styles["title-p"]}>
          <a href="https://shimo.im/docs/2wAlXgDbd1iJ5RAP" target="__blank">
            《账号管理指南》
          </a>
        </div>
        <SearchBar
          isFin={this.isFin}
          v-model={this.params}
          showBatch={this.canBatchInputData}
          on={{
            asyncGet: () =>
              this.getEpopAccountQuery({
                page: 1,
              }),
          }}
        />
        <DataTable
          loading={this.loading}
          list={this.list}
          on={{ getList: this.getEpopAccountQuery }}
          showInput={this.canInputData}
          isFin={this.isFin}
        />
        <div class="paginate-fix-bottom" style="z-index:3">
          {!!this.params.total_count && (
            <VPage
              current={this.params.page}
              total={this.params.total_count}
              page-size={this.params.per_page}
              size-arr={[10, 20, 50]}
              on={{
                changePageSize: (per_page) => {
                  this.params.per_page = per_page;
                  this.params.page = 1;
                  this.$nextTick(this.getEpopAccountQuery);
                },
                pageChange: (page) => {
                  this.params.page = page;
                  this.$nextTick(this.getEpopAccountQuery);
                },
              }}
            />
          )}
        </div>
      </div>
    );
  },
};
